module.exports = __webpack_public_path__ + "img/i_nav_my_new_off.4f89fe12.svg";